module.exports = __webpack_public_path__ + "static/media/Garin Gardiner.d6bbf196.png";